import React from 'react';
import { SIDEBAR_ID } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/metrics/constants.tsx';
import {
	SidebarReady,
	SidebarRenderStart,
} from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/metrics/main.tsx';
import {
	PerformanceMark,
	PerformanceReport,
	RENDER_START_MARK,
	RENDER_END_MARK,
} from '../services/performance-metrics/index.tsx';
import MultiProjectMenu from './multi-project-menu/index.tsx';

/** @deprecated delete when cleaning up getWillShowNav4 */
const MultiProjectSidebarCore = () => (
	<>
		<SidebarRenderStart />
		<PerformanceMark id={RENDER_START_MARK} />
		<MultiProjectMenu />

		{!__SERVER__ && (
			<>
				<SidebarReady id={SIDEBAR_ID.CORE} />
				<PerformanceMark id={RENDER_END_MARK} />
				<PerformanceReport />
			</>
		)}
	</>
);

export default MultiProjectSidebarCore;
